import {
  Button,
  Tabs,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import React from 'react';
import { PiBoatThin, PiCircleThin, PiDiamondThin } from 'react-icons/pi';
import { cn } from '@ais-ui/utils';
import { useLocalization } from '@ais-ui/locale-management';
import { TbTemperature } from 'react-icons/tb';
import { GhVirtualAton } from '../../../assets/icons/GhVirtualAton';

interface TabButtonProps {
  icon: React.ElementType;
  value: string;
  onClick: (value: any) => void;
  tooltipText: string;
}

interface TabsComponentProps {
  setTab: React.Dispatch<
    React.SetStateAction<
      'vessel' | 'aton' | 'virtualAton' | 'methyd' | 'baseStation'
    >
  >;
  tab: 'vessel' | 'aton' | 'virtualAton' | 'methyd' | 'baseStation';
}

const TabButton = ({
  icon: Icon,
  value,
  onClick,
  tooltipText,
}: TabButtonProps) => {
  return (
    <Tooltip>
      <TabsTrigger asChild value={value}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className={cn('w-full justify-center')}
            onClick={() => onClick(value)}
          >
            <Icon
              className={cn('h-6 w-6', 'group-hover/btn:text-primary')}
            ></Icon>
          </Button>
        </TooltipTrigger>
      </TabsTrigger>
      <TooltipContent className="ml-4">{tooltipText}</TooltipContent>
    </Tooltip>
  );
};

export const TargetHoverLabelTabs = ({ tab, setTab }: TabsComponentProps) => {
  const { messages } = useLocalization();
  const onClick = (
    value: 'vessel' | 'aton' | 'virtualAton' | 'methyd' | 'baseStation'
  ) => {
    setTab(value);
  };
  return (
    <Tabs value={tab} className="px-6 pb-6 pt-2">
      <TabsList>
        <TabButton
          icon={PiBoatThin}
          value="vessel"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverVesselTypeLabel}
        ></TabButton>
        <TabButton
          icon={PiDiamondThin}
          value="aton"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverAtonTypeLabel}
        ></TabButton>
        <TabButton
          icon={GhVirtualAton}
          value="virtualAton"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverVirtualAtonTypeLabel}
        ></TabButton>
        <TabButton
          icon={TbTemperature}
          value="methyd"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverMethydTypeLabel}
        ></TabButton>
        <TabButton
          icon={PiCircleThin}
          value="baseStation"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverBaseStationTypeLabel}
        ></TabButton>
      </TabsList>
    </Tabs>
  );
};
